import { theme } from "nectar-ui";
import { DASHBOARD_CHART_TYPES } from "@utils/constants/dashboard/dashboardModuleConstants";
import { ApexOptions } from "apexcharts";

export const MAXIMUM_RESPONSIBLE_NUMBER = 8;
export const MINIMUM_RESPONSIBLE_NUMBER = 1;

export const getBarChartOptions = (responsibleNames: string[]): ApexOptions => {
  return {
    chart: {
      id: DASHBOARD_CHART_TYPES.ACTIVE_LAWSUITS_BY_RESPONSIBLE.chart,
      type: "bar",
      stacked: true,
      height: 380,
      fontFamily: theme.nectar.fontStack.default,
      toolbar: {
        show: false,
      },
    },
    states: {
      active: {
        filter: {
          type: "none",
        },
      },
    },
    plotOptions: {
      bar: {
        distributed: true,
        horizontal: true,
        borderRadius: 5,
        borderRadiusWhenStacked: "last",
        borderRadiusApplication: "end",
        dataLabels: {
          total: {
            enabled: true,
            offsetY: 7,
            style: {
              fontSize: "14px",
              color: theme.nectar.colors.gray900,
              fontWeight: 700,
            },
          },
        },
      },
    },
    colors: [theme.nectar.colors.blue500],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    xaxis: {
      categories: responsibleNames,
      labels: {
        rotateAlways: false,
        trim: true,
        style: {
          fontSize: "14px",
          fontWeight: 300,
          colors: theme.nectar.colors.gray500,
        },
        formatter(value) {
          return Math.round(+value).toString();
        },
      },
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          fontSize: "14px",
          fontWeight: 500,
          colors: theme.nectar.colors.gray500,
        },
      },
    },
    tooltip: {
      x: {
        show: false,
      },
      y: {
        formatter(value) {
          return Math.round(+value).toString();
        },
        title: {
          formatter() {
            return "Ativos:";
          },
        },
      },
    },
    legend: {
      show: false,
    },
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  };
};
